import { Typography } from "@creditsafe/ui-components";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box, Menu, MenuItem } from "@mui/material";
import { camelCase } from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import StatusCircle from "../../../shared/components/status-circle/StatusCircle";
import { CenteredBox } from "../../../shared/styles/common-styles";

export const RiskRating: React.FC<{
  header: string;
  riskRating: string[];
  index: string;
  updateChipLabels: (_key: string, _value: string) => void;
  setRiskRating: (_riskRating: string[]) => void;
  selectedRiskRating: string[];
}> = ({
  header,
  riskRating,
  index,
  updateChipLabels,
  setRiskRating,
  selectedRiskRating,
}) => {
  const { t: translate } = useTranslation(["profile", "common"]);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openPopoverId, setOpenPopoverId] = useState<string | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string
  ): void => {
    setAnchorEl(event.currentTarget);
    setOpenPopoverId(id);
  };

  const handlePopoverClose = (): void => {
    setAnchorEl(null);
    setOpenPopoverId(null);
  };

  const handleSelectedRiskRating = (risk: string): void => {
    updateChipLabels(
      "riskRating",
      `Risk Rating:` + ` ` + translate("risk.rating.options." + risk)
    );
    setRiskRating([risk]);
    setAnchorEl(null);
    setOpenPopoverId(null);
  };

  return (
    <Box component={"span"}>
      <Typography
        key={index}
        aria-label="risk rating"
        variant="h6"
        onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
          handlePopoverOpen(e, header)
        }
      >
        <CenteredBox aria-label="riskRatingValue">
          {translate(header)}
          {openPopoverId === header || selectedRiskRating.length > 0 ? (
            <FilterAltIcon fontSize="small" />
          ) : (
            <FilterAltOutlinedIcon fontSize="small" />
          )}
        </CenteredBox>
      </Typography>
      <Menu
        id={`popover-${header}`}
        anchorEl={anchorEl}
        open={openPopoverId === header}
        onClose={handlePopoverClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ width: "70%" }}
      >
        {riskRating.map((risk) => (
          <MenuItem
            key={risk}
            aria-label={`${risk}`}
            value={risk}
            onClick={() => handleSelectedRiskRating(risk)}
            selected={
              selectedRiskRating.length > 0 && selectedRiskRating[0] === risk
            }
          >
            <StatusCircle
              status={camelCase(`${risk}Risk`)}
              text={translate("risk.rating.options." + risk)}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
